import { post, get} from "@/utils/network";


// 考勤汇总
export const attence = (courseid:string,page:any,size:any) =>  {
  return post('/SummaryApi/attence', {courseid,page,size})
}

// 学生进行考勤
export const checkIn = (
  arg: {
    id:string,
    code:string,
    unusual:string,
    latitude:string,
    longitude:string,
    accuracy:string,
    appid:string,
    clienttype:string
  }, showError = true
) =>  {
  return post('/AttenceApi/checkin', arg, showError)
}

// 考勤弹窗接口-------考勤-列表（学生未参与+考勤未结束）
export const getNotFinishAttence = (courseid:string) =>  {
  return post('/AttenceApi/getNotFinishAttence', {courseid})
}

// 考勤弹窗接口-------考勤-列表（学生未参与+考勤未结束）
export const getNotFinishAttenceStudent = (courseid:string) =>  {
  return post('/AttenceApi/getNotFinishAttenceStudent', {courseid})
}

// 获取签名包
export const getSignPackage = (appid:string,url:string,timestamp:string) =>  {
  return post('/Wechat/getSignPackage', {appid,url,timestamp})
}

// 老师端-pc-考勤-列表（某课程下、出勤率统计、已经结束的考勤）
export const getAttenceList = (
  arg: {
    courseid:string,
    currentPage:string,
    pageSize:string
  }) =>  {
  return post('/AttenceV2Api/getAttenceList', arg)
}

// 二维码考勤----新建现场考勤
export const addNowsAttance = (courseid:string,title:string) =>  {
  return post('/AttenceApi/addNowsAttance', {courseid,title})
}

// 新建数字化考勤
export const addDigitAttence = (courseid:string,title:string) =>  {
  return post('/AttenceApi/addDigitAttence', {courseid,title})
}
// 新建GPS考勤
export const addGPSAttence = (courseid:string,title:string) =>  {
  return post('/AttenceApi/addGPSAttence', {courseid,title})
}
// 新建传统考勤
export const addAttence = (courseid:string,title:string) =>  {
  return post('/AttenceApi/addAttence', {courseid,title})
}

// 签入签出-考勤-新增
export const addCheckinAttence = (courseid:string,title:string,duration:string,checkouttime:string) =>  {
  return post('/AttenceApi/addCheckinAttence', {courseid,title,duration,checkouttime})
}

// 获取某个数字化考勤的情况
export const getDigitAttence = (id:string) =>  {
  return post('/AttenceApi/getDigitAttence', {id})
}

// 考勤二维码的扫码结果
export const AttenceResult = (ticketid:string,expire:string,sign:string) =>  {
  return post('/AttenceApi/AttenceResult', {ticketid,expire,sign},false)
}

// 数字考勤---新考勤码
export const updateDigitAttenceCode = (id:string) =>  {
  return post('/AttenceApi/updateDigitAttenceCode', {id})
}

// 放弃--------删除某个考勤
export const delAttence = (attenceid:string) =>  {
  return post('/AttenceApi/delAttence', {attenceid})
}

// 结束考勤
export const overAttence = (id:string) =>  {
  return post('/AttenceApi/overAttence', {id})
}

// 二维码考勤获取二维码图片
export const getQrCode = (attenceid:string) =>  {
  return post('/AttenceApi/getQrCode', {attenceid})
}

// 获取某次考勤签到人数
export const getDigitSignIn = (id:string) =>  {
  return post('/AttenceApi/getDigitSignIn', {id})
}

// 获取某个考勤的学生的签到情况列表
export const getAttenceStudentLists = (attenceid:string,state:string,page:string,name:string) =>  {
  return post('/AttenceV2Api/getAttenceStudentLists', {attenceid,state,page,name})
}

// 变更考勤----更新某个学生的某次考勤的状态
export const updateState = (studentid:string,attenceid:string,state:string) =>  {
  return post('/AttenceApi/updateState', {studentid,attenceid,state})
}

// GPS---总览
export const getLocation = (attenceid:string) =>  {
  return post('/AttenceApi/getLocation', {attenceid})
}

// 重命名考勤标题
export const renameAttence = (attenceid:string,courseid:string,title:string) =>  {
  return post('/AttenceApi/renameAttence', {attenceid,courseid,title})
}

// 考勤-获取签到人数（签入签出）
export const getDigitSignInCheckin = (attenceid:string) =>  {
  return post('/AttenceApi/getDigitSignInCheckin', {attenceid})
}

// 考勤-获取签到人数（签入签出）
export const getCheckInResult = (attenceid:string) =>  {
  return post('/AttenceApi/getCheckInResult', {attenceid}, false)
}

//获取推送给辅导员的数据，课程模式
export const getCounselorAttenceStudentLists = (params:{coid:string,attenceid:string,search:string,beginTime:number,endTime:number,page:number,pageSize:number}) =>  {
  return post('/AttenceV2Api/getCounselorAttenceStudentLists', params, false)
}

//获取推送给辅导员的数据，行政班模式
export const getAdminClassCounselorAttenceStudentLists = (params:{coid:string,attenceid:string,search:string,beginTime:number,endTime:number,page:number,pageSize:number}) =>  {
  return post('/AttenceV2Api/getAdminClassCounselorAttenceStudentLists', params, false)
}

export default {
  attence,
  checkIn,
  getNotFinishAttence,
  getNotFinishAttenceStudent,
  getSignPackage,
  getAttenceList,
  addNowsAttance,
  addDigitAttence,
  addGPSAttence,
  addAttence,
  getDigitAttence,
  AttenceResult,
  updateDigitAttenceCode,
  delAttence,
  overAttence,
  getQrCode,
  getDigitSignIn,
  addCheckinAttence,
  getAttenceStudentLists,
  updateState,
  getLocation,
  renameAttence,
  getDigitSignInCheckin,
  getCheckInResult,
  getCounselorAttenceStudentLists,
  getAdminClassCounselorAttenceStudentLists
}
